// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"192":"a8e36503","580":"4b72b92c"}[chunkId] + ".css";
};